import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import QuickRegister from "@/pages/QuickRegister";
import Accounts from "@/pages/Accounts";
import Budget from "@/pages/Budget";
import Movements from "@/pages/Movements";
import Settings from "@/pages/Settings";
import UpcomingPayments from "@/pages/UpcomingPayments";
import PendingInvoices from "@/pages/PendingInvoices";
import { Vault } from "lucide-react";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="w-12 h-12 rounded-2xl bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center animate-pulse">
      <Vault className="w-6 h-6 text-emerald-500" />
    </div>
  </div>
);

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function PublicHome() {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (user) return <Navigate to="/dashboard" replace />;
  return <Login />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<PublicHome />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/registro" element={<Protected><QuickRegister /></Protected>} />
      <Route path="/cuentas" element={<Protected><Accounts /></Protected>} />
      <Route path="/presupuesto" element={<Protected><Budget /></Protected>} />
      <Route path="/movimientos" element={<Protected><Movements /></Protected>} />
      <Route path="/proximos-pagos" element={<Protected><UpcomingPayments /></Protected>} />
      <Route path="/pendientes-facturar" element={<Protected><PendingInvoices /></Protected>} />
      <Route path="/configuracion" element={<Protected><Settings /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CurrencyProvider>
            <AppRouter />
          </CurrencyProvider>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
